// src/auth/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function PrivateRoute({ children, requirePatient = false }) {
  const { isAuthed, role } = useAuth();

  // ① ログインしてない → ログインページへ
  if (!isAuthed) {
    return <Navigate to="/" replace />;
  }

  // ② 主治医 or エキスパート医師で、
  //    「患者選択が必要なページ」にアクセスしている場合
  if (requirePatient && (role === "attending_physician" || role === "expert_physician")) {
    const hasPatient = !!sessionStorage.getItem("patient");
    if (!hasPatient) {
      const redirectTo =
        role === "attending_physician" ? "/patient-selection" : "/ap-selection";
      return <Navigate to={redirectTo} replace />;
    }
  }

  // ③ 通常どおり描画
  return children;
}
